import React from 'react';
export var isIconPaddingEnabled = function isIconPaddingEnabled(children, preventIconsOffset) {
  return Boolean(!preventIconsOffset && React.Children.toArray(children).some(function (x) {
    return /*#__PURE__*/React.isValidElement(x) && x.props.icon;
  }));
};